
import { clone, setWith, curry } from 'lodash/fp';

export { get, set, merge } from 'lodash';

export const setIn = curry(
    (path, value, obj) => setWith(clone, path, value, clone(obj)),
);
